import { useProjectStore } from '../stores/projectStore';

export function SaveIndicator() {
  const { isSaving, error } = useProjectStore();

  if (!isSaving && !error) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {isSaving ? (
        <div className="bg-white shadow-lg rounded-lg px-4 py-2 flex items-center gap-2 text-sm border border-gray-200">
          <div className="w-4 h-4 border-2 border-primary-600 border-t-transparent rounded-full animate-spin" />
          <span className="text-gray-600">Salvataggio...</span>
        </div>
      ) : error ? (
        <div className="bg-red-50 shadow-lg rounded-lg px-4 py-2 flex items-center gap-2 text-sm border border-red-200">
          <span className="text-red-500">⚠</span>
          <span className="text-red-700">Errore nel salvataggio</span>
        </div>
      ) : null}
    </div>
  );
}
